module.exports = __webpack_public_path__ + "static/media/control_img.930b896e.jpg";